"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _Icon = require("../../Icon");

var GalleryArrow = function GalleryArrow(_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      onSwitchImage = _ref.onSwitchImage,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'text.main' : _ref$color,
      _ref$positionX = _ref.positionX,
      positionX = _ref$positionX === void 0 ? -196 : _ref$positionX,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref, ["icon", "disabled", "onSwitchImage", "color", "positionX"]);

  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var handleClick = (0, _react.useCallback)(function () {
    if (!disabled) {
      onSwitchImage();
    }
  }, [disabled, onSwitchImage]);
  var cursor = {
    cursor: disabled ? 'default' : 'pointer'
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    position: "absolute",
    top: positionX,
    width: 40,
    height: 40,
    borderRadius: "50%",
    bgcolor: (0, _styles.alpha)(palette.common.white, disabled ? 0.4 : 1),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: 1,
    borderColor: "text.disabled"
  }, boxProps, {
    style: cursor,
    onClick: handleClick
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    style: cursor,
    icon: icon,
    color: color
  }));
};

var _default = GalleryArrow;
exports["default"] = _default;